  <div *ngIf="icon" class="-card-category-product-asset">
  <app-link [to]="to"><lucide-icon [name]="icon" class="card-category-icon"></lucide-icon></app-link> 
</div>
<a [attr.href]="totype === 'card' ? to ? to : null : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="card-product -title" [ngClass]="totype === 'card' ? '' : '-header-link'">
    <div class="-subtitle -fontDisplayThin">{{subtitle}}</div>
    <div class="-title-card-category-product">
      <app-link [to]="to" *ngIf="totype === 'title'"><h3>{{title}}</h3></app-link>
      <h3 *ngIf="totype === 'card'">{{title}}</h3>
      <version-pill [label]="version" *ngIf="version"></version-pill>
    </div>
  </div>
  <ng-content></ng-content>
</a>